export default __webpack_public_path__ + "static/media/bdedu1.1cad17bd.PNG";